export default "__VITE_ASSET__D1R$r_kw__"